import
{
  PlayerDropdownsContainer,
  SelectContainer,
  ButtonsContainer,
} from './PlayersDropdownSelects.styles';
import { CustomSelect, CustomAutoSelect } from '../../../components/Inputs/CustomSelect/CustomSelect';
import LinkButton from '../../../components/Buttons/LinkButton/LinkButton';
import { Skeleton } from '@mui/material';

const getPlayerName = (id, options) =>
{
  if (id)
  {
    let player = options.find(e => { return e.id == id })
    return player?.label;
  }
  return '';
}
const PlayersDropdownSelects = ({ choices, dropdownOptions, handleChange, handleAdd, handleReset, loading }) =>
{


  return (
    <PlayerDropdownsContainer>
      {!choices || choices.length == 0 &&
        <SelectContainer
          key={0}
        >
          <Skeleton variant="rounded" width={294} height={41}>
            <Skeleton variant="rectangular" width={294} height={41} sx={{ bgcolor: 'grey.900' }} />
          </Skeleton>

        </SelectContainer>
      }
      {
        choices && choices.length > 0 && choices.map((choice, idx) => (
          <SelectContainer
            key={idx}
          >
            <CustomAutoSelect
              key={idx}
              name={`player${idx}`}
              label="Players"
              placeholder={'Select option'}
              onChange={handleChange(idx)}
              value={getPlayerName(choices[idx], dropdownOptions)}
              options={dropdownOptions}
              disabled={loading}
            />
          </SelectContainer>
        ))
      }

      <ButtonsContainer>
        {!dropdownOptions.length ?

          (<>
            <Skeleton variant="rounded" >
              <LinkButton
                text={'Add Player'}
                disabled={true}
              />

              <LinkButton
                text={'Reset'}
                disabled={true}
              />
            </Skeleton>
          </>)
          :
          (<>{choices.length < 2 &&
            <LinkButton
              text={'Add Player'}
              onClick={handleAdd}
              isAdd
              disabled={loading}
            />}
            <LinkButton
              text={'Reset'}
              onClick={handleReset}
              isReset
              disabled={loading}
            />
          </>)
        }
      </ButtonsContainer>
    </PlayerDropdownsContainer >
  );
};

export default PlayersDropdownSelects;
